export default __webpack_public_path__ + "static/media/alien0.47cd6964.png";